<div class="container-fluid">
  <div class="row">
    <div
      class="col-md-12 footer-copyright d-flex flex-wrap align-items-center justify-content-between"
    >
      <p class="mb-0 f-w-600">Copyright 2024 © Mofi theme by pixelstrap</p>
      <p class="mb-0 f-w-600">
        Hand crafted & made with
        <app-common-svg-icon [class]="'footer-icon'" [icon]="'footer-heart'"></app-common-svg-icon>
      </p>
    </div>
  </div>
</div>
